import React from 'react';
import talkOfTribe1 from '../../assets/images/talk-of-tribe1.png';
import talkOfTribe2 from '../../assets/images/talk-of-tribe2.png';
import talkOfTribe3 from '../../assets/images/talk-of-tribe3.png';
import chevronRight from '../../assets/images/chevron-right.svg';
import chevronLeft from '../../assets/images/chevron-left.png';

const TalkOfTribe = () => {
  return ( 
    <div className="talk-of-tribe">
      <div className="text-center">
        <p className="font-weight-extrabold fs-18 text-black">THE TALK OF THE TRIBE</p>
        <p className="text-primary fs-32 font-weight-thin">Meet the people driving us forward</p>
      </div>
      <div className="talk-of-tribe-desktop">
        <div id="carouselExampleControls1" className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            <li data-target="#carouselExampleControls1" data-slide-to="0" className="active"></li>
            <li data-target="#carouselExampleControls1" data-slide-to="1"></li>
            <li data-target="#carouselExampleControls1" data-slide-to="2"></li>
          </ol>
          <div className="carousel-inner">
            <div className="carousel-item active h-300">
              <div className="row mt-5">
                <div className="col-md-4 panel-member">
                  <span className="font-weight-semibold">Project Associate</span>
                  <p className="fs-14 text-gray mt-3 slider-text">SmartDrive has a very inclusive work culture with<br/> 60% of the leadership roles held by women! I love that there are ongoing skill enhancement programs and constant employee engagement activities that bolster team spirit and individual health at all times.</p>
                </div>
                <div className="col-md-4 panel-member">
                  <span className="font-weight-semibold">Simulation Engineer</span>
                  <p className="fs-14 text-gray mt-3">The best thing about working at Smartdrive is that I’m constantly learning new things, despite having worked over here for over a year. Both the management and the employees are experimental, willing to innovate often and just great to work with!</p>
                </div>
                <div className="col-md-4 panel-member">
                  <span className="font-weight-semibold">Technical Support Engineer</span>
                  <p className="fs-14 text-gray mt-3 slider-text">Working in SmartDrive is a breeze! The fun and open work culture, well-rounded benefits, and learning programmes give us abundant opportunities for growth. The approachable management is just the icing on the cake.</p>
                </div>          
              </div>
            </div>
            <div className="carousel-item h-300">
              <div className="row mt-5">
                <div className="col-md-4 panel-member">
                  <span className="font-weight-semibold">Customer Success Manager</span>
                  <p className="fs-14 text-gray mt-3 slider-text">Smartdrive has fantastic leadership and a brilliant work culture. No idea is a bad idea, and I like that there is mutual respect between the employees, given that we don’t have a traditional hierarchical structure.</p>
                </div>
                <div className="col-md-4 panel-member">
                  <span className="font-weight-semibold">Associate Analyst</span>
                  <p className="fs-14 text-gray mt-3 slider-text">The Smart Tribe and the management make working here a very enjoyable experience. The ever-clean offices, availability of healthy food, healthcare benefits and travel allowance given here are unparalleled.</p>
                </div>
                <div className="col-md-4 panel-member">
                  <span className="font-weight-semibold">Lead Analyst</span>
                  <p className="fs-14 text-gray mt-3 slider-text">For me, commuting to and fro from office is the most convenient thing! I love the open work culture and that I can approach anyone from the upper management, without any hesitation.</p>
                </div>
              </div>
            </div>
            <div className="carousel-item h-300">
              <div className="row mt-5">
                <div className="col-md-4 panel-member">
                  <span className="font-weight-semibold">Support Engineer</span>
                  <p className="fs-14 text-gray mt-3 slider-text">This is the 1st company I’ve worked in, where there is a genuine concern for the employees’ healthcare - whether it is with our “No Smoking” perks or our daily nutritious meals.</p>
                </div>
              </div>
            </div>
            <a className="carousel-control-prev" href="#carouselExampleControls1" role="button" data-slide="prev">
              <span className="carousel-control-prev" aria-hidden="true"><img src={chevronLeft} alt="Chevron Left" /></span>
              <span className="sr-only">Previous</span>
            </a>
            <a className="carousel-control-next" href="#carouselExampleControls1" role="button" data-slide="next">
              <span className="carousel-control-next" aria-hidden="true"><img src={chevronRight} alt="Chevron Right" /></span>
              <span className="sr-only">Next</span>
            </a>
          </div> 
        </div>
      </div>
      <div className="talk-of-tribe-mobile">
        <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
          <ol className="carousel-indicators">
            <li data-target="#carouselExampleControls" data-slide-to="0" className="active"></li>
            <li data-target="#carouselExampleControls" data-slide-to="1"></li>
            <li data-target="#carouselExampleControls" data-slide-to="2"></li>
            <li data-target="#carouselExampleControls" data-slide-to="3"></li>
            <li data-target="#carouselExampleControls" data-slide-to="4"></li>
            <li data-target="#carouselExampleControls" data-slide-to="5"></li>
            <li data-target="#carouselExampleControls" data-slide-to="6"></li>
          </ol>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <span className="font-weight-semibold">Project Associate</span>
              <p className="fs-14 text-gray mt-3 slider-text">SmartDrive has a very inclusive work culture with 60% of the leadership roles held by women! I love that there are ongoing skill enhancement programs and constant employee engagement activities that bolster team spirit and individual health at all times.</p>
            </div>
            <div className="carousel-item">
              <span className="font-weight-semibold">Simulation Engineer</span>
              <p className="fs-14 text-gray mt-3 slider-text">The best thing about working at Smartdrive is that I’m constantly learning new things, despite having worked over here for over a year. Both the management and the employees are experimental, willing to innovate often and just great to work with!</p>
            </div>
            <div className="carousel-item">
              <span className="font-weight-semibold">Technical Support Engineer</span>
              <p className="fs-14 text-gray mt-3 slider-text">Working in SmartDrive is a breeze! The fun and open work culture, well-rounded benefits, and learning programmes give us abundant opportunities for growth. The approachable management is just the icing on the cake.</p>
            </div>
            <div className="carousel-item">
              <span className="font-weight-semibold">Customer Success Manager</span>
              <p className="fs-14 text-gray mt-3 slider-text">Smartdrive has fantastic leadership and a brilliant work culture. No idea is a bad idea, and I like that there is mutual respect between the employees, given that we don’t have a traditional hierarchical structure.</p>
            </div>
            <div className="carousel-item">
              <span className="font-weight-semibold">Associate Analyst</span>
              <p className="fs-14 text-gray mt-3 slider-text">The Smart Tribe and the management make working here a very enjoyable experience. The ever-clean offices, availability of healthy food, healthcare benefits and travel allowance given here are unparalleled.</p>
            </div>
            <div className="carousel-item">
              <span className="font-weight-semibold">Lead Analyst</span>
              <p className="fs-14 text-gray mt-3 slider-text">For me, commuting to and fro from office is the most convenient thing! I love the open work culture and that I can approach anyone from the upper management, without any hesitation.</p>
            </div>
            <div className="carousel-item">
              <span className="font-weight-semibold">Support Engineer</span>
              <p className="fs-14 text-gray mt-3 slider-text">This is the 1st company I’ve worked in, where there is a genuine concern for the employees’ healthcare - whether it is with our “No Smoking” perks or our daily nutritious meals.</p> 
            </div>
          </div>
          <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span className="carousel-control-prev" aria-hidden="true"><img src={chevronLeft} alt="Chevron Left" /></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span className="carousel-control-next" aria-hidden="true"><img src={chevronRight} alt="Chevron Right" /></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
   );
}
 
export default TalkOfTribe;